// Form options shared between different forms

// Legacy export for backward compatibility (will be deprecated)
export const originOfAssetsOptions = [
  { value: 'business_activities', label: 'Business activities' },
  { value: 'investments', label: 'Investments' },
  { value: 'sale_of_assets', label: 'Sale of assets' },
  { value: 'other', label: 'Other (please specify)' },
];

// Function to get translated origin of assets options
export const getOriginOfAssetsOptions = (t: (key: string) => string) => [
  {
    value: 'business_activities',
    label: t('originOfAssets.businessActivities'),
  },
  {
    value: 'investments',
    label: t('originOfAssets.investments'),
  },
  {
    value: 'sale_of_assets',
    label: t('originOfAssets.saleOfAssets'),
  },
  {
    value: 'other',
    label: t('originOfAssets.other'),
  },
];
